import { FC, createElement, useState } from 'react';
import { useHttpQuery } from 'packages/http-client/react';
import { createLogActionRequest } from 'apps/acp/packages/webapi';
import { useTalkdeskChatButtonTheme } from './talkdesk-chatbot.theme';
import { TalkdeskCustomChatButton } from 'packages/talkdesk-chatbot/react';
import { useIsReactNativeWebView } from 'packages/use-is-react-native-webview';

export const TalkdeskLogWebAction = () => {
  useHttpQuery(
    createLogActionRequest({
      actionLog: 'CHATBOT_CLICKED'
    })
  );

  return null;
};

export const TalkdeskChatButton: FC<{ authed?: boolean }> = ({
  authed = false
}) => {
  const [clicked, setClicked] = useState<boolean>(false);
  const { leftIcon, rightIcon } = useTalkdeskChatButtonTheme();
  const isReactNativeWebView = useIsReactNativeWebView();
  return (
    <div onClick={() => setClicked(true)}>
      {authed && clicked && <TalkdeskLogWebAction />}
      {!isReactNativeWebView && (
        <TalkdeskCustomChatButton
          leftIconColor={leftIcon}
          rightIconColor={rightIcon}
          authed={authed}
        />
      )}
    </div>
  );
};
